import request from '@/plugins/axios'

//获取直播列表
export function listActivityLive(params) {
  return request({
    url: '/activityLive/listActivityLive',
    method: 'get',
    params
  })
}

//获取直播内容列表
export function listContent(params) {
  return request({
    url: '/activityLive/listContent',
    method: 'get',
    params
  })
}

//添加直播
export function addActivityLive(data) {
  return request({
    url: '/activityLive/addActivityLive',
    method: 'post',
    data
  })
}

//添加直播内容
export function addContent(data) {
  return request({
    url: '/activityLive/addContent',
    method: 'post',
    data
  })
}

//删除直播
export function deleteActivityLive(params) {
  return request({
    url: '/activityLive/deleteActivityLive/' + params,
    method: 'get'
  })
}

//删除直播内容
export function deleteContent(params) {
  return request({
    url: '/activityLive/deleteContent/' + params,
    method: 'get'
  })
}

//查询单个征稿活动
export function getActivityLive(params) {
  return request({
    url: '/activityLive/getActivityLive/' + params,
    method: 'get'
  })
}

//修改直播信息
export function updateActivityLive(data) {
  return request({
    url: '/activityLive/updateActivityLive',
    method: 'post',
    data
  })
}

//修改直播内容信息
export function updateContent(data) {
  return request({
    url: '/activityLive/updateContent',
    method: 'post',
    data
  })
}


//指派给我的直播活动
export function myActivityLive(params) {
  return request({
    url: '/activityLive/myActivityLive',
    method: 'post',
    params
  })
}


//获取直播数量
export function resourceCount(params) {
  return request({
    url: '/activityLive/resourceCount',
    method: 'get',
    params
  })
}